import React from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "reactstrap";

function GridHeader() {
  const { isModalPage } = useSelector((state) => ({
    isModalPage: state.Layout.isModalPage,
  }));

  if (isModalPage) return <></>;

  return (
    <div>
      <Row>
        <Col>
          <h5 className="text-color-azul1 font-size-24 fw-semibold mb-4">
            Locais de Desembarque
          </h5>
        </Col>
      </Row>
    </div>
  );
}

export default GridHeader;
